declare global {
  interface Window {
    _env_: {
      REACT_APP_HOSTNAME: string
      REACT_APP_ENV: string
      KEYCLOAK_SERVER: string
      KEYCLOAK_CLIENT_ID: string
      REACT_SENTRY_ORG: string
      REACT_SENTRY_PROJECT: string
      REACT_SENTRY_DSN: string
      REACT_APP_HIDDEN_LEAP_CHANNEL: boolean
      ENABLE_WORKING_HOURS: boolean
      ENABLE_EXPORT_CHAT: boolean
      AMPLITUDE_API_KEY: string
      FRESH_CHAT_TOKEN: string
      FRESH_CHAT_HOST: string
      REACT_APP_PARTNER_SOURCE: boolean
      REACT_SUPPORT_LINK: string
      DEV_MODE?: boolean
      FARO_ENABLE?: boolean
      FARO_URL?: string
      FARO_API_KEY?: string
      FARO_SAMPLING_RATE?: number
      FIREBASE_ENABLED?: boolean
      FIREBASE_API_KEY?: string
      FIREBASE_AUTH_DOMAIN?: string
      FIREBASE_DATABASE_URL?: string
      FIREBASE_PROJECT_ID?: string
      FIREBASE_STORAGE_BUCKET?: string
      FIREBASE_MESSAGING_SENDER_ID?: string
      FIREBASE_APP_ID?: string
      FIREBASE_MEASUREMENT_ID?: string
      SIGNAL_HCAPTCHA_SITEKEY?: string
    }
  }
}

type TEnv = 'dev_aw' | 'dev' | 'qa_aw' | 'qa' | 'perf' | 'uat' | 'hsf'

interface EnvironmentConfig {
  REACT_APP_HOSTNAME: string
  REACT_APP_ENV: string
  REACT_SENTRY_ORG: string
  REACT_SENTRY_PROJECT: string
  REACT_SENTRY_DSN: string
  KEYCLOAK_SERVER: string
  KEYCLOAK_CLIENT_ID: string
  REACT_APP_HIDDEN_LEAP_CHANNEL: boolean
  REACT_APP_PARTNER_SOURCE: boolean
  REACT_SUPPORT_LINK: string
  ENABLE_WORKING_HOURS: boolean
  ENABLE_EXPORT_CHAT: boolean
  AMPLITUDE_API_KEY: string
  FRESH_CHAT_TOKEN: string
  FRESH_CHAT_HOST: string
  DEV_MODE?: boolean
  SIGNAL_HCAPTCHA_SITEKEY: string
}

export const baseConfig: EnvironmentConfig = {
  REACT_APP_HOSTNAME: 'http://localhost:4001',
  REACT_APP_ENV: 'development',
  REACT_APP_HIDDEN_LEAP_CHANNEL: true,
  REACT_APP_PARTNER_SOURCE: false,
  REACT_SUPPORT_LINK: 'https://support.leap.expert/support/tickets/new',
  ENABLE_WORKING_HOURS: false,
  ENABLE_EXPORT_CHAT: true,
  AMPLITUDE_API_KEY: '',
  FRESH_CHAT_TOKEN: '',
  FRESH_CHAT_HOST: '',
  REACT_SENTRY_ORG: 'leapxpert',
  REACT_SENTRY_PROJECT: 'admin-web',
  REACT_SENTRY_DSN:
    'https://29987a2b039e4d47a43197ebfde90873@o112155.ingest.sentry.io/1530153',
  KEYCLOAK_CLIENT_ID: 'sso',
  KEYCLOAK_SERVER: '',
  SIGNAL_HCAPTCHA_SITEKEY: '',
}

export const envConfigs: Record<TEnv, EnvironmentConfig> = {
  dev_aw: {
    ...baseConfig,
    REACT_APP_HOSTNAME: 'https://public.leapxpert.dev',
    KEYCLOAK_SERVER: 'https://web.leapxpert.dev/auth',
    ENABLE_WORKING_HOURS: true,
    DEV_MODE: true,
  },
  dev: {
    ...baseConfig,
    REACT_APP_HOSTNAME: 'https://public.dev-az.leapxpert.dev',
    KEYCLOAK_SERVER: 'https://web.dev-az.leapxpert.dev/auth',
    ENABLE_WORKING_HOURS: true,
    DEV_MODE: true,
  },
  qa: {
    ...baseConfig,
    KEYCLOAK_SERVER: 'https://web.qa-az.leapxpert.app/auth',
    ENABLE_WORKING_HOURS: true,
    FRESH_CHAT_TOKEN: '00a25444-27c6-4575-b879-f892ddcd94f4',
    FRESH_CHAT_HOST: 'https://lxpportal.freshchat.com',
    DEV_MODE: true,
  },
  qa_aw: {
    ...baseConfig,
    KEYCLOAK_SERVER: 'https://web.qa.leapxpert.app/auth',
    ENABLE_WORKING_HOURS: true,
    FRESH_CHAT_TOKEN: '00a25444-27c6-4575-b879-f892ddcd94f4',
    FRESH_CHAT_HOST: 'https://lxpportal.freshchat.com',
    DEV_MODE: true,
  },
  perf: {
    ...baseConfig,
    KEYCLOAK_SERVER: 'https://public.evilmonkey.leapxpert.dev/auth',
    ENABLE_WORKING_HOURS: true,
    FRESH_CHAT_TOKEN: '00a25444-27c6-4575-b879-f892ddcd94f4',
    FRESH_CHAT_HOST: 'https://lxpportal.freshchat.com',
    DEV_MODE: true,
  },
  uat: {
    ...baseConfig,
    REACT_APP_ENV: 'uat',
    KEYCLOAK_SERVER: 'https://web.uat.leapxpert.dev/auth',
    ENABLE_WORKING_HOURS: false,
    DEV_MODE: true,
  },
  hsf: {
    ...baseConfig,
    REACT_APP_ENV: 'hsf',
    KEYCLOAK_SERVER: 'https://web-c15e88a.leapxpert.app/auth',
    ENABLE_WORKING_HOURS: false,
    DEV_MODE: true,
  },
}

let env = window._env_ || envConfigs.dev

if (process.env.REACT_APP_DEBUG === 'true') {
  const selectedEnv =
    envConfigs[process.env.REACT_APP_DEBUG_ENVIRONMENT as TEnv]

  env = selectedEnv || env
}

export default env
